import {ISelect} from '../interface/ISelect';

const mapAndFilter = (
  data: any,
  JSON: ISelect[],
  key: string,
  mapWithKey?: 'label' | 'value'
): ISelect[] => {
  const mappedAndFilteredCountries: any = [];
  const processedCountryCodes = new Set();

  data?.forEach((item: any) => {
    const country = JSON.find((c) =>
      mapWithKey ? c[mapWithKey] === item?.[key] : c?.value === item[key]
    );

    if (country && !processedCountryCodes.has(country.value)) {
      const {value, label} = country;
      mappedAndFilteredCountries.push({
        value,
        label
      });
      processedCountryCodes.add(country.value);
    }
  });

  return mappedAndFilteredCountries;
};

export default mapAndFilter;
